// extracted by mini-css-extract-plugin
export default {"blog":"style_blog__1glWy","blog__title":"style_blog__title__By25l"};